import React from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import ClickAndDrag from './ClickDrag';
import AlwaysVisibleScroll from './AlwaysVisibleScroll';
import BothSideScroll from './BothSideScroll';
import HorizontalScroll from './HorizontalScroll';
import SmallSizeScroll from './SmallSizeScroll';
import VerticalScroll from './VerticalScroll';

const ScrollableContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Scrollable' parent='Bonus Ui' title='Scrollable' />
      <Row>
        <ClickAndDrag />
        <SmallSizeScroll />
        <BothSideScroll />
        <HorizontalScroll />
        <AlwaysVisibleScroll />
        <VerticalScroll />
      </Row>
    </Container>
  );
};

export default ScrollableContainer;
